import { useEffect, useRef, useState } from "react";
import { useInView, animate } from "framer-motion";
import { STATS } from "./data";
import { Reveal, Eyebrow } from "./Primitives";

const Count = ({ v }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.3 });
  const [n, setN] = useState(v);
  useEffect(() => {
    if (!inView) return undefined;
    const c = animate(0, v, { duration: 1.6, ease: [0.16, 1, 0.3, 1], onUpdate: (x) => setN(Math.round(x)) });
    return () => c.stop();
  }, [inView, v]);
  return <span ref={ref}>{n.toLocaleString("en-US")}</span>;
};

export const Stats = () => (
  <section data-testid="stats-section" className="relative py-28 md:py-36">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal className="flex flex-col md:flex-row md:items-end justify-between gap-6">
        <div>
          <Eyebrow>Workspace snapshot</Eyebrow>
          <h2 className="font-display mt-5 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">Counted, scoped, and labeled.</h2>
        </div>
        <p className="max-w-sm text-sm text-[var(--muted)]">Read-only development API, default Meta filter (≥ 30 aligned residues), reviewed 10 October 2026. Scoped counts — not the whole archive.</p>
      </Reveal>
      <div className="mt-14 grid grid-cols-2 lg:grid-cols-3 border-l border-t border-[var(--line)]">
        {STATS.map((s, i) => (
          <Reveal key={s.l} delay={i * 0.05} className="border-r border-b border-[var(--line)] p-6 md:p-10">
            <div data-testid={`stat-value-${i}`} className={`font-display text-4xl sm:text-6xl lg:text-7xl font-extrabold tracking-tight ${i === 3 ? "text-[var(--amber)]" : ""}`}><Count v={s.v} /></div>
            <p className="mt-3 text-sm text-[var(--muted)]">{s.l}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
